export default {
  peserta: [
    {
      icon: 'mdi-account-remove',
      title: 'Set Mengundurkan Diri',
      event: 'onUndurDiri',
      akses: 'psp-peserta-lulus.mundur',
    },
    {
      icon: 'mdi-account-check',
      title: 'Set Batal Undur Diri',
      event: 'onBatalUndurDiri',
      akses: 'psp-peserta-lulus.batal-mundur',
    },
  ],
  pa: [
    {
      icon: 'mdi-pencil',
      title: 'Ubah Status',
      event: 'onSetStatus',
      akses: 'psp-pelatih-ahli-lulus.save-mundur',
    },
  ],
  pelaksana: [
    {
      icon: 'mdi-eye',
      title: 'Lihat Detail',
      event: 'onDetailPeserta',
    },
    {
      icon: 'mdi-pencil',
      title: 'Ubah Status',
      event: 'onSetStatusPelaksana',
      akses: 'psp-peserta-pelaksana.ganti-kasek',
    },
  ],
};
